import React, { useEffect, useState } from 'react';

import { Button, Card, Col, Modal, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';

export default function HotelGuestReviews({ hotelId }) {
  const [show, setShow] = useState(false);
  const [reviews, setReviews] = useState([]);
  const showDetail = () => setShow(true);
  const handleClose = () => setShow(false);
  const [loading, setLoading] = useState(true);

  useEffect(async () => {
    const url = `${process.env.API_URL}/hotel/${hotelId}/review`;

    const fetchData = async () => {
      try {
        const response = await fetch(url, { credentials: 'include' });
        const json = await response.json();
        if (json.review_data) setReviews(json.review_data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setReviews([]);
      }
    };
    await fetchData();
  }, []);

  if (loading) {
    return (
      <>
        <Skeleton height={10} count={20} className="my-5" />
      </>
    );
  }
  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header className="bg-dark" closeButton closeVariant="white">
          <Modal.Title>Reviews</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark">
          {reviews.map((review) => {
            if (review.good_description === '' && review.bad_description === '') return false;
            return (
              <Card border="light" bg="dark" key={Math.random()} text="white" className="mb-2 w-100">
                <Card.Header>
                  {review.review_text} - {review.user_name} - ({review.creation_date})
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={3} className="d-flex justify-content-center flex-column ">
                      <h2 className="w-100 select-color text-center">{review.average_rating}</h2>
                      <h4 className="mt-2 w-100 select-color text-center">{review.average_rating_description}</h4>
                    </Col>
                    <Col md={9}>
                      <Row>
                        <p>
                          <b>Pros: </b> {review.good_description}
                        </p>
                      </Row>
                      <Row>
                        <p>
                          <b>Cons: </b>
                          {review.bad_description}
                        </p>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            );
          })}
        </Modal.Body>
      </Modal>
      <Button className="rounded-pill bg-transparent border-white" onClick={() => showDetail()}>
        Guest Ratings
      </Button>
    </>
  );
}
